import React, { Component } from 'react';
import AbacusSelect from '../Components/AbacusSelect';
import Grid from '@material-ui/core/Grid';
import AbacusDatePicker from '../Components/AbacusDatePicker';
import Button from '@material-ui/core/Button';
import Moment from '@date-io/moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import {ApxReportMenu} from './../Enums/Enums';
import AbacusTextField from './../Components/AbacusTextField';
import AbacusCheckbox from './../Components/AbacusCheckbox';

/// Report Class. Uses generic input 
/// form and create all reports.
class Reports extends Component {
  // Variables
  reportGroup = ApxReportMenu.Finance;
  data;
  financeReportTypes = [
    {value:"ApxAnalyticsMonthlyBS",text:"Monthly Billing Summary"},
    {value:"ApxInterchangeQual",text:"Interchange Qualification Report"},
    {value:"NetsuiteCB",text:"Chargebacks"},
    {value:"NetsuiteR",text:"Rejections"},
    {value:"GrossBilling",text:"Gross Billing"},
    {value:"ApxEnsureBill",text:"Ensure Updates"},
    {value:"ApxPayNowAnalyticsR",text:"PayNow Statistics"},
  ];
  supportReportTypes = [
    {value:"ApxAnalyticsBS",text:"Billing Summary"},
    {value:"ApxAnalyticsCTD",text:"Comprehensive Transaction Detail"},
    {value:"ApxAnalyticsTHR",text:"Customer Transaction History"},
    {value:"ApxAnalyticsCB",text:"Chargebacks"},
    {value:"ApxAnalyticsOSR",text:"Onboarding Status"},
    {value:"ApxSweepHold",text:"Sweep Hold Allerts"},
    {value:"ApxAnalyticsOSSR",text:"Onboarding by Submitted Date"},
  ];
  statusList = [
    {value:"0",text:"All"},
    {value:"1",text:"Pending"},
    {value:"2",text:"Won"},
    {value:"3",text:"Lost"}
  ];
  currentState={
    reportType:"ApxAnalyticsMonthlyBS",
    reportTypes:this.financeReportTypes,
    applicationType: "16761,16669,16670,16713,16800",
    status: "0"
  };

  applicationTypes = [
    {value:"16761,16669,16670,16713,16800",text:"All"},
    {value:"16761",text:"Abacus NEXT"},
    {value:"16669",text:"Abacus Law"},
    {value:"16670",text:"Amicus Attorney"},
    {value:"16713",text:"Amicus Cloud"},
    {value:"16800",text:"Office Tools"},
    {value:"17122",text:"Office Tools Cloud"},
  ];

  applicationTypesClients = [
    {value:"16669",text:"Abacus Law"},
    {value:"16670",text:"Amicus Attorney"},
    {value:"16713",text:"Amicus Cloud"},
    {value:"16800",text:"Office Tools"},
    {value:"17122",text:"Office Tools Cloud"},
  ];

  applicationTypesNoALL = [
    {value:"16761",text:"Abacus NEXT"},
    {value:"16669",text:"Abacus Law"},
    {value:"16670",text:"Amicus Attorney"},
    {value:"16713",text:"Amicus Cloud"},
    {value:"16800",text:"Office Tools"},
    {value:"17122",text:"Office Tools Cloud"},
  ];

  ClientReportTypes = {
      AmicusAttorney: [
        {value:"AmicusAttorneyBSD",text:"Billing Statement Detail"},
        {value:"AmicusAttorneyBSS",text:"Billing Statement Summary"},
        {value:"AmicusAttorneyCB",text:"Chargebacks"},
        {value:"AmicusAttorneyR",text:"Rejections"}
      ],
      AmicusOnline: [
        {value:"AmicusOnlineBSD",text:"Billing Statement Detail"},
        {value:"AmicusOnlineBSS",text:"Billing Statement Summary"},
        {value:"AmicusOnlineCB",text:"Chargebacks"},
        {value:"AmicusOnlineR",text:"Rejections"}
      ],
      Abacus: [
        {value:"AbacusBSD",text:"Billing Statement Detail"},
        {value:"AbacusBSS",text:"Billing Statement Summary"},
        {value:"AbacusCB",text:"Chargebacks"},
        {value:"AbacusR",text:"Rejections"}
      ],
      OfficeTools: [
        {value:"OfficeToolsBSD",text:"Billing Statement Detail"},
        {value:"OfficeToolsBSS",text:"Billing Statement Summary"},
        {value:"OfficeToolsCB",text:"Chargebacks"},
        {value:"OfficeToolsR",text:"Rejections"}
      ],
      OfficeToolsCloud: [
        {value:"OfficeToolsCloudBSD",text:"Billing Statement Detail"},
        {value:"OfficeToolsCloudBSS",text:"Billing Statement Summary"},
        {value:"OfficeToolsCB",text:"Chargebacks"},
        {value:"OfficeToolsR",text:"Rejections"}
      ],
  }

  // Constructor initiate callback methods and sets initial state
  constructor(props) {
    super(props);  

    this.data = props.data;
    this.data.Finance.showProgress = this.showProgress.bind(this)
    this.props.data.Main.ReportChangeCallback = this.menuChange.bind(this);
    
    let moment = new Moment();
    let startDateMoment = moment.date();
    let startDate = moment.addDays(startDateMoment,-1); 
    
    // Keep state in current state because the state can be changed only once per event.
    this.currentState = {
        reportType:"ApxAnalyticsMonthlyBS",
        reportTypes: this.financeReportTypes,
        statusList: this.statusList,
        applicationTypes: this.applicationTypes,
        status: "0",
        isOnlySummary: false,
        customerNumber:"",
        customerLabel:"Customer ID",
        applicationType:"16713",
        startDate: startDate,
        endDate: moment.date(),
        showProgress: false,
        dateFormat:"MM/YYYY",
        dateView:["year", "month"],
        isDisableSummary: true,
        isDisableCustomer: true,
        isDisableStatus: true,
        isDisableApplication: false,
        Snackbar_Open: false,
        Snackbar_ErrorText: "",
        disablePDF: false
    }

    // Set state
    this.state = {...this.currentState}
  }

  // Report menu change event.
  menuChange(value){
    if(value === ApxReportMenu.Support){
      this.currentState.reportTypes = this.supportReportTypes;
      this.currentState.reportType = "ApxAnalyticsBS";
      this.currentState.applicationType = "16713";
    }else if(value === ApxReportMenu.Finance){
      this.currentState.reportTypes = this.financeReportTypes;
      this.currentState.reportType = "ApxAnalyticsMonthlyBS";
    }else if(value === ApxReportMenu.ClientFacing){
      this.currentState.reportTypes = this.ClientReportTypes.AmicusOnline;
      this.currentState.reportType = "AmicusOnlineBSD";
      this.currentState.applicationTypes = this.applicationTypesClients;
    }

    this.reportGroup = value;
    this.setControlsState();
  }

  // callback for showing Progress circle.
  showProgress(show){
    this.setState({
      showProgress:show
    });
  }

  // Drop Down Change Events
  dropDownChange(controlName, event){
    if(controlName === "ApplicationType"){
      this.currentState.applicationType = event.target.value;
    }else if(controlName === "ReportType"){
      this.currentState.reportType = event.target.value;
    }else if(controlName === "Status"){
      this.currentState.status = event.target.value;
    }

    this.setControlsState();
  }

  // Text Field Change Events
  textFieldChange(event){
    this.currentState.customerNumber = event.target.value;
    this.setControlsState();
  }

  /// Adjust controls and set states. State can be set only 
  /// once so group all events changes.
  setControlsState(){
    let isDisableSummary = true;
    let isDisableCustomer = true;
    let isDisableStatus = true;
    let isDisableApplication = true;
    let dtFormat = "DD/MM/YYYY";
    let dtView = ["year", "month", "date"];
    let disablePDF=false;
    let applicationTypes = this.currentState.applicationTypes;
    let applicationType = this.currentState.applicationType;
    let customerLabel = "Client ID"
    
    // Finance Reports
    if(this.reportGroup === ApxReportMenu.Finance){
      isDisableSummary = true;
      isDisableCustomer = true;
      isDisableStatus = true;
      isDisableApplication = true;
      if(this.currentState.reportType === "ApxAnalyticsMonthlyBS"){
        isDisableApplication = false;
        dtFormat = "MM/YYYY";
        dtView = ["year", "month"];
      }
      else if(this.currentState.reportType === "NetsuiteCB"){
        isDisableStatus = false;
        applicationType = "16761";
      }
      else if(this.currentState.reportType === "NetsuiteR"){
        isDisableStatus = false;
        applicationType = "16761";
      }
      else if(this.currentState.reportType === "ApxInterchangeQual"){
        applicationType = "16761";
        disablePDF=true;
      }
      else if(this.currentState.reportType === "GrossBilling"){
        applicationType = "16761";
        disablePDF=true;
      }
      else if(this.currentState.reportType === "ApxEnsureBill"){
        applicationType = "16761";
        disablePDF=true;
      }
      else if(this.currentState.reportType === "ApxPayNowAnalyticsR"){
        applicationTypes = this.applicationTypes;
        disablePDF=true;
        isDisableApplication=false;
      }
    // Support Reports
    }else if(this.reportGroup === ApxReportMenu.Support){
      isDisableSummary = true;
      isDisableCustomer = true;
      isDisableStatus = true;
      isDisableApplication = true;
      applicationTypes = this.applicationTypesNoALL;
      if(this.currentState.reportType === "ApxAnalyticsBS"){
        isDisableApplication = false;
        isDisableCustomer = false;
      }
      else if(this.currentState.reportType === "ApxAnalyticsOSR" || this.currentState.reportType === "ApxAnalyticsCTD" || this.currentState.reportType === "ApxAnalyticsTHR" || this.currentState.reportType === "ApxAnalyticsOSSR" ){
        isDisableCustomer = false;
        isDisableApplication = false;
      }
      else if(this.currentState.reportType === "ApxSweepHold"){
        isDisableCustomer = false;
        isDisableApplication = false;
        disablePDF=true;
      }
      else if(this.currentState.reportType === "ApxAnalyticsCB"){
        isDisableStatus = false;
        isDisableApplication = false;
        isDisableCustomer = false;
        isDisableSummary = false;
      }
     
      if(this.currentState.applicationType === "16713"){
        customerLabel = "Firm ID";
      }else{
        customerLabel = "Customer ID";
      }
    // Client Facing Reports
    }else if(this.reportGroup === ApxReportMenu.ClientFacing){
      isDisableSummary = true;
      isDisableCustomer = false;
      isDisableStatus = true;
      isDisableApplication = false;

      // Application type - Abacus Law
      if(this.currentState.applicationType === "16669"){
        if(this.currentState.reportTypes !== this.ClientReportTypes.Abacus){
          this.currentState.reportType = this.ClientReportTypes.Abacus[0].value;
        }
        this.currentState.reportTypes = this.ClientReportTypes.Abacus;
      // Application type - Amicus Attorney
      }else if(this.currentState.applicationType === "16670"){
        if(this.currentState.reportTypes !== this.ClientReportTypes.AmicusAttorney){
          this.currentState.reportType = this.ClientReportTypes.AmicusAttorney[0].value;
        }
        this.currentState.reportTypes = this.ClientReportTypes.AmicusAttorney;
      // Application type - Amicus Cloud
      }else if(this.currentState.applicationType === "16713"){
        if(this.currentState.reportTypes !== this.ClientReportTypes.AmicusOnline){
          this.currentState.reportType = this.ClientReportTypes.AmicusOnline[0].value;
        }
        this.currentState.reportTypes = this.ClientReportTypes.AmicusOnline;
      // Application type - Office Tools
      }else if(this.currentState.applicationType === "16800"){
        if(this.currentState.reportTypes !== this.ClientReportTypes.OfficeTools){
          this.currentState.reportType = this.ClientReportTypes.OfficeTools[0].value;
        }
        this.currentState.reportTypes = this.ClientReportTypes.OfficeTools;
      }
      else if(this.currentState.applicationType === "17122"){
        if(this.currentState.reportTypes !== this.ClientReportTypes.OfficeToolsCloud){
          this.currentState.reportType = this.ClientReportTypes.OfficeToolsCloud[0].value;
        }
        this.currentState.reportTypes = this.ClientReportTypes.OfficeToolsCloud;
      }
    }

    // Final set state
    this.setState({
      isDisableSummary: isDisableSummary,
      isDisableCustomer: isDisableCustomer,
      isDisableStatus: isDisableStatus,
      isDisableApplication: isDisableApplication,
      applicationTypes:applicationTypes,
      applicationType:applicationType,
      reportType:this.currentState.reportType,
      reportTypes:this.currentState.reportTypes,
      status:this.currentState.status,
      dateFormat:dtFormat,
      dateView:dtView,
      disablePDF:disablePDF,
      customerLabel: customerLabel,
      endDate:this.currentState.endDate,
      startDate:this.currentState.startDate,
      isOnlySummary:this.currentState.isOnlySummary,
      customerNumber:this.currentState.customerNumber,
  });
}

  /// Call to server to get report bytes.
  getReport(format){
    let moment = new Moment();
    let startDateText = moment.format(this.state.startDate,"YYYY-MM-DD");
    let endDateText = moment.format(this.state.endDate,"YYYY-MM-DD");
    let status = 0;
    if (this.state.reportType === "NetsuiteCB" || this.state.reportType === "ApxAnalyticsCB")
    {
      status = this.state.status;
    }
    let isOnlySummary = "";
    if (this.state.reportType === "ApxAnalyticsCB")
    {
      isOnlySummary = this.state.isOnlySummary?"true":""; // This value is what is required by server.
    }
    
    let reportParameters = {
        ReportName: this.state.reportType,
        StartDate: startDateText,
        EndDate: endDateText,
        AffiliateId: this.state.applicationType,
        CustomerNumber: this.state.customerNumber,
        Sort: status,
        FirmName:isOnlySummary,
        isCSV: format === "CSV"? true:false,
    }

    // Get report bytes
    this.data.Service.GetReport(reportParameters);
  }

  /// Events from Date and checkbox controls.
  onChange(controlName, value){
    if(controlName === "to"){
      this.currentState.endDate = value;
    }else if(controlName === "from"){
      this.currentState.startDate = value;
    }else if(controlName === "summary"){
      this.currentState.isOnlySummary = value.target.checked;
    }

    /// Adjust controls and set states
    this.setControlsState();
  }

  /// Render html
  render() {
    return (
      <div>
        <Grid container spacing={1}>
            <Grid item xs={12}>
              <div style={{height:"30px"}}></div>
            </Grid>

            <Grid item xs={4}>
                <AbacusSelect error={false} style={{width:"300px"}} value={this.state.reportType} list={this.state.reportTypes} label="Report Type"  onChange={this.dropDownChange.bind(this,"ReportType")}></AbacusSelect>
            </Grid>
            <Grid item xs={3}>
                <AbacusDatePicker format={this.state.dateFormat} views={this.state.dateView} value={this.state.startDate} onChange={this.onChange.bind(this,"from")} label="from"></AbacusDatePicker>
            </Grid>
            <Grid item xs={3}>
                <AbacusDatePicker format={this.state.dateFormat} views={this.state.dateView} value={this.state.endDate} onChange={this.onChange.bind(this,"to")} label="to"></AbacusDatePicker>
            </Grid>
            <Grid item xs={2}>
              <AbacusSelect disabled={this.state.isDisableApplication} error={false} style={{width:"150px"}} value={this.state.applicationType} list={this.state.applicationTypes} label="Application"  onChange={this.dropDownChange.bind(this,"ApplicationType")}></AbacusSelect>
            </Grid>

            <Grid item xs={4}>  
              <AbacusTextField disabled={this.state.isDisableCustomer} value={this.state.customerNumber} style={{marginTop:"0px",width:"300px"}} Name={this.state.customerLabel} helperText="" onChange={this.textFieldChange.bind(this)}></AbacusTextField>
            </Grid>
            <Grid item xs={3}>
              <AbacusSelect disabled={this.state.isDisableStatus} error={false} style={{width:"245px"}} value={this.state.status} list={this.state.statusList} label="Status"  onChange={this.dropDownChange.bind(this,"Status")}></AbacusSelect>
            </Grid>
            <Grid item xs={3} style={{paddingTop:"17px",textAlign:"left",paddingLeft:"5px"}}>
              <AbacusCheckbox value={this.state.isOnlySummary} disabled={this.state.isDisableSummary} label="Show only summary" onChange={this.onChange.bind(this,"summary")}></AbacusCheckbox>
            </Grid>
            <Grid item xs={2}>
            </Grid>
            
            <Grid item xs={4}>
            </Grid>
            <Grid item xs={4}>
              {this.state.showProgress?<CircularProgress style={{marginTop:"0px"}} />:null}
            </Grid>
            <Grid item xs={2}>
            {!this.state.showProgress?<Button onClick={this.getReport.bind(this,"CSV")} style={this.style} variant="contained" color="primary">
                CSV FORMAT
              </Button>:null}
            </Grid>
            <Grid item xs={2}>
            {!this.state.showProgress?<Button disabled={this.state.disablePDF} onClick={this.getReport.bind(this,"PDF")} style={this.style} variant="contained" color="primary">
                RUN REPORT
              </Button>:null}
            </Grid>
        </Grid>
      </div>
    );
  }
}

export default Reports;